/** The names spark's layout is addressed by - a group to animate, a box to scroll, a box to watch. */
export enum ChatElement {
  COLUMN_GROUP = 'SPARK_LAYOUT',
  /* The four columns, named for what they hold rather than where they sit - the order is a layout
     decision and the reader of a test is asking about the talent grid, not the fourth one. */
  HISTORY_COLUMN = 'HISTORY_COLUMN',
  TRANSCRIPT_COLUMN = 'TRANSCRIPT_COLUMN',
  DRAWER_TOGGLES_COLUMN = 'DRAWER_TOGGLES_COLUMN',
  MATCH_GRID_COLUMN = 'MATCH_GRID_COLUMN',
  SCROLLER = 'CHAT_SCROLLER',
  SCROLL_CONTENT = 'CHAT_SCROLL_CONTENT',
}
